<template>
<ValidationObserver ref="observer">
  <form ref="edit_pool_form" @submit.prevent="handleSubmit(updateWarehouse)">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Warehouse Name</label>
                  <md-input v-model="warehouse_name" required/>
                  <validation-error :errors="apiValidationErrors.warehouse_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed</label>
                  <md-select v-model="warehouse_pool_id" required>
                    <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                      {{ option.pool_name }}
                    </md-option>
                  </md-select>

                  <validation-error :errors="apiValidationErrors.warehouse_pool_id" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Warehouse Head</label>
                  <md-select v-model="warehouse_head_id" required>
                    <md-option v-for="option in options_user_list" :key="option.value" :value="option.id">
                      {{ option.name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.warehouse_head_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                  <md-checkbox v-model="warehouse_workshop">Warehouse Workshop</md-checkbox>
                  <validation-error
                    :errors="apiValidationErrors.warehouse_workshop"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
              </validation-provider>
            </div>
        </div>

      </md-card-content>
      

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('harus', {
  ...required,
  message: 'Field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    name: "edit-pool",
    
    props:{
      data_id:null
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

   data: () => ({
      warehouse: [],
      warehouse_name: null,
      warehouse_pool_id : null,
      warehouse_head_id: null,
      warehouse_workshop: null,
      options_user_list: null,
      options_pool_list: null
    }),

    created() {
      this.getWarehouseData();
      this.getPool();
      this.getWarehouseHead();
    },


    methods: {

      // fungsi untuk mendapatkan data yang akan di edit dengan id yang dikirim bersamaan dengan route
      async getWarehouseData(){
        //check apakah id ada di route
        if(this.data_id.id){
          
        //jika ada ambil data dari api
        await this.$store.dispatch("workshop_warehouse/get", this.data_id.id)
        this.warehouse = await this.$store.getters["workshop_warehouse/warehouse"]
        this.warehouse_pool_id = this.warehouse.warehouse_pool.id
        this.warehouse_head_id = this.warehouse.warehouse_head ? this.warehouse.warehouse_head.id : null
        this.warehouse_name = this.warehouse.warehouse_name
        this.warehouse_workshop = this.warehouse.warehouse_workshop == 1? true:false

        }
        else{
          //jika tidak ada kembali ke list
          this.$parent.$parent.modalCloseEdit();
        }
      },

      async getPool(){
        await this.$store.dispatch("workshop_pool/list")
        this.options_pool_list = await this.$store.getters["workshop_pool/list"]
      },

      async getWarehouseHead(){
        await this.$store.dispatch("users/list_workshop_head")
        this.options_user_list = await this.$store.getters["users/list"]
      },

      // validasi menggunakan sweetalert  sebelum mengubah data
      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateWarehouse(id)
          }
        });
    },


    // fungsi edit
      async updateWarehouse() {
        const data = {
          type: "workshop_warehouses",
          id: this.warehouse.id,
          warehouse_name: this.warehouse_name,
          warehouse_head_id: this.warehouse_head_id,
          warehouse_pool_id: this.warehouse_pool_id,
          warehouse_workshop: this.warehouse_workshop

        }

        try {
          //kirim data ke server
          await this.$store.dispatch("workshop_warehouse/update", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "data changed successfully.")
          //kembali ke list
          this.$parent.$parent.modalCloseEdit();
        } catch (e) {
          //panggil notifikasi error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }
    }
  };
</script>
